<template>
  <div class="box">
    <form class="section" @submit.prevent="updateCurrentRowNumber()">
      <div class="field">
        <label class="label">Rows</label>
        <div class="control">
          <input type="number" class="input" v-model="new_people_chair_row_number">
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button type="submit" class="button is-link">Submit</button>
        </div>
      </div>
    </form>
    <div class="section">
      <div class="field">
        <label class="label">Name</label>
        <div class="control">
          <input type="text" class="input" v-model="new_people_name">
        </div>
      </div>
      <div class="tile is-ancestor is-link">
        <div class="tile is-12">
          <div class="tile is-parent">
            <article class="tile is-child notification has-text-centered is-success">
              <h1 class="title is-1">Screen is here</h1>
            </article>
          </div>
        </div>
      </div>
      <div class="tile is-ancestor" v-for="(new_people_chair_row, index) in new_people_chair_list" :key="index">
        <div class="tile is-12">
          <div class="tile is-parent" v-for="(new_people_chair_row_seat, index_seat) in new_people_chair_row" :key="index_seat" @click="selectSeat(new_people_chair_row_seat, index, index_seat)">
            <article :class="{'tile': true, 'is-child': true, 'notification': true, 'has-text-centered': true, 'no-padding': new_people_chair_row_seat.is_selected === 1, 'is-link': new_people_chair_row_seat.is_selected === 0, 'is-warning': new_people_chair_row_seat.is_selected === 1}">
              <span v-text="new_people_chair_row_seat.title"></span>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      new_people_chair_row_number: 0,
      new_people_name: '',
      new_people_chair_list: []
    }
  },
  created () {
    this.getCurrentRowNumber()
  },
  methods: {
    getCurrentRowNumber () {
      var self = this
      self.flyGetSession('task/current_seat_row_number')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.new_people_chair_row_number = response.data.data
          self.generateRows()
        } else {
          self.$router.push('/panel/profile')
        }
      }).catch(function (response) {
        console.log(response)
      })
    },
    updateCurrentRowNumber () {
      var self = this
      self.flyPostSession('task/update_seat_row_number', {
        number: self.new_people_chair_row_number
      }).then(function (response) {
        if (response.data.response_code === 1) {
          self.generateRows()
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    },
    getSeatData () {
      var self = this
      self.flyPostSession('task/get_seat_data', {
        chair_list: this.new_people_chair_list
      }).then(function (response) {
        if (response.data.response_code === 1) {
          self.new_people_chair_list = response.data.data
          self.updateSeat()
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    },
    generateRows () {
      var allChairs = []
      for (var i = 0; i < this.new_people_chair_row_number; i++) {
        var tempRow = []

        for (var j = 0; j < 12; j++) {
          var tempData = {
            // id: j,
            title: '',
            is_selected: 0
          }

          tempRow.push(tempData)
        }

        allChairs.push(tempRow)
      }

      this.new_people_chair_list = allChairs
      this.getSeatData()
    },
    selectSeat (rowData, index, indexSeat) {
      if (this.new_people_name !== '') {
        this.new_people_name = this.new_people_name.substring(0, 8)
        this.new_people_chair_list[index][indexSeat].title = this.new_people_name
        this.new_people_chair_list[index][indexSeat].is_selected = 1
      } else {
        this.new_people_chair_list[index][indexSeat].title = ''
        this.new_people_chair_list[index][indexSeat].is_selected = 0
      }
      this.updateSeat()
    },
    updateSeat () {
      var self = this
      self.flyPostSession('task/update_seat', {
        chair_list: this.new_people_chair_list
      }).then(function (response) {
        if (response.data.response_code === 1) {
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-padding{
    padding-left: 0;
    padding-right: 0;
  }
</style>


// WEBPACK FOOTER //
// src/pages/panel/floorarea/NewPeopleChair.vue